import { Card, Form, Switch, Button, Typography, Space, Select, InputNumber } from 'antd'
import { SaveOutlined, ExperimentOutlined, ApiOutlined, CloudServerOutlined } from '@ant-design/icons'
import { useNavigate } from 'react-router-dom'

const { Title, Text } = Typography
const { Option } = Select

const FallbackAppSettings = () => {
  const navigate = useNavigate()
  const [form] = Form.useForm()

  const handleSave = (values: any) => {
    console.log('Settings saved:', values)
    // Here you would typically save to backend
  }

  return (
    <div style={{ 
      width: '100vw', 
      minHeight: '100vh', 
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      padding: 0,
      margin: 0,
      overflow: 'auto'
    }}>
      {/* Header */}
      <div style={{
        background: 'rgba(255, 255, 255, 0.1)',
        backdropFilter: 'blur(10px)',
        borderBottom: '1px solid rgba(255, 255, 255, 0.2)',
        padding: '16px 24px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          <div>
            <Title level={3} style={{ margin: 0, color: '#ffffff' }}>
              Settings
            </Title>
            <Text style={{ color: 'rgba(255, 255, 255, 0.8)' }}>
              Configure Fallback App preferences
            </Text>
          </div>
        </div>
        <Button 
          onClick={() => navigate('/fallbackapp/dashboard')}
          style={{
            background: 'rgba(255, 255, 255, 0.2)',
            border: '1px solid rgba(255, 255, 255, 0.3)',
            color: '#ffffff'
          }}
        >
          Back to Dashboard
        </Button>
      </div>

      {/* Settings Content */}
      <div style={{ padding: '24px', maxWidth: '800px', margin: '0 auto' }}>
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSave}
          initialValues={{
            experimentalFeatures: true,
            apiRateLimit: 1000,
            cacheEnabled: true,
            debugMode: false,
            environment: 'development'
          }}
        >
          {/* Experimental Features */}
          <Card
            style={{
              marginBottom: '16px',
              background: 'rgba(255, 255, 255, 0.95)',
              border: 'none',
              borderRadius: '12px'
            }}
          >
            <Space direction="vertical" style={{ width: '100%' }}>
              <Title level={5}>
                <ExperimentOutlined /> Experimental Features
              </Title>
              
              <Form.Item name="experimentalFeatures" valuePropName="checked">
                <Space>
                  <Switch />
                  <Text>Enable experimental features</Text>
                </Space>
              </Form.Item>

              <Form.Item name="betaProgram" valuePropName="checked">
                <Space>
                  <Switch />
                  <Text>Join beta program</Text>
                </Space>
              </Form.Item>

              <Form.Item name="telemetry" valuePropName="checked">
                <Space>
                  <Switch defaultChecked />
                  <Text>Share anonymous usage data</Text>
                </Space>
              </Form.Item>
            </Space>
          </Card>

          {/* API Configuration */}
          <Card
            style={{
              marginBottom: '16px',
              background: 'rgba(255, 255, 255, 0.95)',
              border: 'none',
              borderRadius: '12px'
            }}
          >
            <Space direction="vertical" style={{ width: '100%' }}>
              <Title level={5}>
                <ApiOutlined /> API Configuration
              </Title>
              
              <Form.Item 
                name="apiRateLimit" 
                label="Rate Limit (requests/hour)"
              >
                <InputNumber 
                  min={100} 
                  max={10000} 
                  step={100}
                  style={{ width: '100%' }}
                />
              </Form.Item>

              <Form.Item name="cacheEnabled" valuePropName="checked">
                <Space>
                  <Switch />
                  <Text>Enable response caching</Text>
                </Space>
              </Form.Item>

              <Form.Item 
                name="timeout"
                label="Request Timeout (seconds)"
              >
                <InputNumber 
                  min={5} 
                  max={60} 
                  defaultValue={30}
                  style={{ width: '100%' }}
                />
              </Form.Item>
            </Space>
          </Card>

          {/* Infrastructure */}
          <Card
            style={{
              marginBottom: '16px',
              background: 'rgba(255, 255, 255, 0.95)',
              border: 'none',
              borderRadius: '12px'
            }}
          >
            <Space direction="vertical" style={{ width: '100%' }}>
              <Title level={5}>
                <CloudServerOutlined /> Infrastructure
              </Title>
              
              <Form.Item 
                name="environment"
                label="Environment"
              >
                <Select>
                  <Option value="development">Development</Option>
                  <Option value="staging">Staging</Option>
                  <Option value="production">Production</Option>
                </Select>
              </Form.Item>

              <Form.Item name="debugMode" valuePropName="checked">
                <Space>
                  <Switch />
                  <Text>Enable debug mode</Text>
                </Space>
              </Form.Item>

              <Form.Item name="autoScale" valuePropName="checked">
                <Space>
                  <Switch />
                  <Text>Auto-scale resources</Text>
                </Space>
              </Form.Item>
            </Space>
          </Card>

          {/* Save Button */}
          <Button 
            type="primary" 
            htmlType="submit"
            icon={<SaveOutlined />}
            size="large"
            style={{
              width: '100%',
              background: '#8b5cf6',
              border: 'none',
              height: '48px'
            }}
          >
            Save Settings
          </Button>
        </Form>
      </div>
    </div>
  )
}

export default FallbackAppSettings